import _Tooltip from "@material-ui/core/esm/Tooltip";
import _IconButton from "@material-ui/core/esm/IconButton";
import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { Price } from 'swag-client-common/utils/price';
import { DeleteBinIcon } from 'swag-client-common/components/svg/delete-bin.svg';
import { variables } from 'swag-client-common/styles/variables-js';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import { GoodieGiveawayProductQuantityInput } from 'swag-client-common/components/partials/goodie-giveaway-product-quantity-input';
import classes from './checkout-product-card.scss';
const IconButtonStyled = withStyles({
  root: {
    backgroundColor: variables.colorGreyBoxDefaultBtn,
    width: '30px',
    height: '30px'
  }
})(_IconButton);
const DeleteBinIconStyled = withStyles({
  root: {
    width: '13px',
    stroke: variables.colorRed
  }
})(DeleteBinIcon);
export const CheckoutProductCard = ({
  product,
  showDeleteButton = true,
  onDeleteProduct,
  onChangeQuantity
}) => {
  const handleDeleteProduct = () => {
    onDeleteProduct(product);
  };
  const renderProductName = () => /*#__PURE__*/React.createElement("div", {
    className: classes.nameWrapper
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.name
  }, name));
  const renderPriceSection = () => /*#__PURE__*/React.createElement("div", {
    className: classes.priceWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.quantityInput, classes.priceTitle)
  }, /*#__PURE__*/React.createElement("p", null, "Quantity:"), /*#__PURE__*/React.createElement(GoodieGiveawayProductQuantityInput, {
    onChange: quantity => onChangeQuantity(product._id, quantity),
    quantity: quantity
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.priceTitle
  }, /*#__PURE__*/React.createElement("p", null, "Item price:"), /*#__PURE__*/React.createElement("p", {
    className: classes.price
  }, Price.formatPrice(price))));
  const renderDeleteButton = () => /*#__PURE__*/React.createElement("div", {
    className: classes.removeWrapper
  }, /*#__PURE__*/React.createElement(_Tooltip, {
    title: "Delete product",
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButtonStyled, {
    onClick: handleDeleteProduct
  }, /*#__PURE__*/React.createElement(DeleteBinIconStyled, {
    viewBox: "0 0 18 20"
  }))));
  const {
    name,
    image,
    price,
    quantity
  } = product;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container,
    "data-productId": product._id
  }, isMobile() ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.section
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.imageWrapper
  }, /*#__PURE__*/React.createElement("img", {
    alt: name,
    src: image
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.section
  }, renderProductName(), /*#__PURE__*/React.createElement("div", {
    className: classes.subSection
  }, renderPriceSection(), showDeleteButton && renderDeleteButton()))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.section
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.imageWrapper
  }, /*#__PURE__*/React.createElement("img", {
    alt: name,
    src: image
  })), renderProductName()), /*#__PURE__*/React.createElement("div", {
    className: classes.section
  }, renderPriceSection(), showDeleteButton && renderDeleteButton())));
};